var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAwakening(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1083_7662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0031 20.0138H110.522C111.334 20.0138 112.147 19.9678 112.959 20.0436C114.833 20.2197 115.73 21.0838 115.938 22.9258C115.998 23.6465 116.014 24.3701 115.987 25.0928V110.961C115.987 111.592 116.014 112.228 115.957 112.857C115.762 115.024 114.898 115.836 112.675 115.98C112.044 116.015 111.41 115.993 110.779 115.993H25.1998C20.4604 115.98 20 115.511 20 110.673V25.3474C20 20.5421 20.5254 20.0138 25.2187 20.0138C39.4802 20.0048 53.7416 20.0048 68.0031 20.0138ZM49.1566 67.8018L68.0193 86.7442L86.6058 68.1729L67.6483 49.2116L49.1566 67.8018ZM25.9337 110.086C26.7841 110.151 27.3988 110.243 28.0163 110.24C39.0044 110.213 49.9907 110.175 60.9753 110.126C61.0348 110.126 61.1052 110.004 61.1459 109.928C61.1865 109.853 61.1973 109.777 61.043 110.3L25.9337 75.1832V110.086ZM110.062 74.7173C107.819 76.1042 75.865 108.141 74.8548 109.956C77.972 110.497 108.131 110.375 110.062 109.79V74.7173ZM25.912 61.5446C26.5024 61.1572 26.8193 61.0028 27.0495 60.7861C38.4366 49.3534 49.8174 37.9142 61.1919 26.4688C61.2271 26.4309 61.1919 26.3063 61.173 26.2332C61.1526 26.1728 61.1243 26.1155 61.089 26.0625H25.912V61.5446ZM74.5082 26.0138C77.7851 30.1338 108.258 60.2715 110.048 61.2006V26.0138H74.5082ZM84.0926 93.015C82.121 92.5491 53.5602 92.5789 51.8107 93.0556L67.9354 109.192L84.0926 93.015ZM109.525 67.5526C104.293 62.3843 98.9119 56.7934 92.9376 51.1159V84.1627L109.525 67.5526ZM43.0902 51.598L26.8409 67.8506L43.0902 84.1032V51.598ZM67.8406 26.4255C63.9868 29.5704 52.5121 41.3453 51.6346 43.0573C56.0626 43.6397 82.8305 43.4067 84.2605 42.8595L67.8406 26.4255ZM47.7863 62.2326C51.6048 59.253 61.1107 49.4581 61.869 47.8085H47.7863V62.2326ZM88.1061 61.8317C88.6748 58.416 88.5096 49.5854 87.7838 47.6432C85.5062 47.6432 83.1799 47.6432 80.8319 47.6432C78.5543 47.6432 76.2766 47.6893 73.9774 47.7164L88.1061 61.8317ZM62.026 88.234C60.1628 85.4521 49.5466 75.0153 47.8079 74.1864V88.234H62.026ZM88.228 88.1961V74.0537C86.1183 75.278 75.3423 86.0833 74.1182 88.1961H88.228Z",
    fill: "#7BDEFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1083_7662",
    x: 0,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.482353 0 0 0 0 0.870588 0 0 0 0 0.988235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1083_7662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1083_7662",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAwakening);
export default __webpack_public_path__ + "static/media/ico-awakening.3a63766e6613a493da6b36e891500c66.svg";
export { ForwardRef as ReactComponent };